'use client';

import { useEffect } from 'react';
import Script from 'next/script';

export default function GorgiasChatWidget({ path }: { path: string }) {
    useEffect(() => {
        const container = document.getElementById('gorgias-chat-container');
        if (container) {
            if (path !== '/faq') {
                container.style.display = 'none';
            } else {
                container.style.display = 'block';
            }
        }
    }, [path]);

    if (path !== '/faq') return null;

    return (
        <>
            <Script
                id="gorgias-chat-widget-install-v3"
                src="https://config.gorgias.chat/bundle-loader/01GYCCX2M7A9E1GGE27DHTFN1Q"
                strategy="afterInteractive"
            />
            <Script
                src="https://bundle.9gtb.com/loader.js?g_cvt_id=55d464a4-2326-4301-9f84-1ea20d836094"
                strategy="lazyOnload"
            />
        </>
    );
}
